class ExitProgram
    constructor: (el) ->
        @.$el = el
        @.$diaryDemandRangeEl = @.$el.querySelector '.exit-program__diary__demand__range'
        @.$diaryFeelingsEnterButton = @.$el.querySelector '.exit-program__diary__feelings__enter'
        @.$diaryFeelingsEntriesEl = @.$el.querySelector '.exit-program__diary__feelings__entries'
        @.$diaryFeelingsInput = @.$el.querySelector '.exit-program__diary__feelings__input'
        @.$diarySmokedButtonsEl = @.$el.querySelector '.exit-program__diary__smoked__buttons'
        @.$diarySmokedNoButton = @.$el.querySelector '.exit-program__diary__smoked__no'
        @.$diarySmokedYesButton = @.$el.querySelector '.exit-program__diary__smoked__yes'
        @.$loginButton = @.$el.querySelector '.exit-program__login'
        @.$resetStartButton = @.$el.querySelector '.exit-program__diary__reset-start'
        @.$startButton = @.$el.querySelector '.exit-program__start-button'
        @.$startQuiz = @.$el.querySelector '.exit-program__start__survey'
        @.$startQuizConfig = @.$el.querySelector '.exit-program__start__survey-config'

        @.apiBase = @.$el.dataset?.apiBase ? false
        @.apiCreateUserProfile = 'createUserProfile/'
        @.apiMethod = @.$el.dataset?.apiMethod ? 'GET'
        @.apiResetStart = 'resetStart/'
        @.apiSaveDemand = 'saveDemand/'
        @.apiSaveFeeling = 'saveFeeling/'
        @.apiSaveSmoked = 'saveSmoked/'
        @.day = @.$el.querySelector('.exit-program__day')?.dataset?.day ? false
        @.demandRangeChangeDelay = 800
        @.demandRangeChangeInterval = undefined
        @.diaryButtonActiveColor = @.$el.dataset?.dabc ? 'green'
        @.loginOverlayId = @.$el.dataset?.loginOverlayId ? false
        @.shownDay = @.$el.querySelector('.exit-program__diary__control__day')?.dataset?.shownDay ? false
        @.uid = @.$el.dataset?.uid ? '0'

        @.$el.classList.add 'exit-program--bound'
        @.CheckForQuiz()
        @.InitEvents()
        return

    AddDiaryFeelingsEntry: ->
        if @.$diaryFeelingsInput && @.$diaryFeelingsEntriesEl
            entryText = @.$diaryFeelingsInput.querySelector 'input'
                .value
            if entryText != ""
                @.$diaryFeelingsInput.dispatchEvent new CustomEvent 'input-delete', {bubbles: false}
                entryEl = document.createElement 'div'
                entryEl.classList.add 'exit-program__diary__feelings__entry'
                entryEl.innerHTML = entryText
                @.$diaryFeelingsEntriesEl.appendChild entryEl
                @.UpdateDiaryFeelings(entryText)
        return
    
    CheckForQuiz: ->
        if !@.$startQuiz && @.$startQuizConfig
            window.exitProgramStart = JSON.parse @.$startQuizConfig.textContent
            @.$startQuiz = window.CreateQuiz {
                attrs: {
                    class: ['exit-program__start__survey']
                }
                dataMethod: 'window'
                dataSource: 'exitProgramStart'
            }
            @.$startQuizConfig.after @.$startQuiz
        if @.$startQuizConfig
            @.$startQuizConfig.remove()
        return

    CreateUserProfile: (fulfilledSheets) ->
        if @.apiBase && @.apiMethod == 'POST' && fulfilledSheets.length > 0
            self = @
            try
                age = 18
                cigarettesPerDay = 20
                demand = 4
                motivation = 1
                salutation = 'Du'
                smokeStart = 0
                smokeStop = 0
                fulfilledSheets.forEach (fulfilledSheet) ->
                    if typeof fulfilledSheet.name != 'undefined'
                        if fulfilledSheet.name == 'age-salutation'
                            age = fulfilledSheet.answers['age'] ? age
                            salutation = salutation
                        if fulfilledSheet.name == 'cigarettes-per-day'
                            cigarettesPerDay = fulfilledSheet.answers['cigarettes-per-day'] ? cigarettesPerDay
                        if fulfilledSheet.name == 'demand'
                            demand = fulfilledSheet['answer'] ? demand
                        if fulfilledSheet.name == 'motivation'
                            motivation = fulfilledSheet.answers['motivation'] ? motivation
                        if fulfilledSheet.name == 'smoke-start'
                            smokeStart = fulfilledSheet.answers['smoking-years'] ? smokeStart
                        if fulfilledSheet.name == 'smoke-stop'
                            smokeStop = fulfilledSheet.answers['smoke-stop'] ? smokeStop
                    return
                body = {
                    ausstiegUid: @.uid
                    age: age
                    cigarettesPerDay: cigarettesPerDay
                    demand: demand
                    motivation: motivation
                    salutation: salutation
                    smokeStart: smokeStart
                    smokeStop: smokeStop
                }
                request = window.appUtils.XMLHttpRequest @.apiMethod, @.apiBase + @.apiCreateUserProfile
                    , ->
                        if request.responseText && request.responseText != ""
                            try
                                answer = JSON.parse request.responseText
                                self.$el.classList.add 'exit-program--start-survey-completed'
                            catch error
                                console.log "Fehler beim Versuch die Antwort der Schnittstelle zu verarbeiten"
                                return
                        else
                            console.log "Die Anfrage zur Schnittstelle lieferte ein leeres Ergebnis"
                    , ->
                        console.log "Bei der Anfrage an die Schnittstelle ist leider ein Fehler aufgetreten"
                        return
                    , JSON.stringify(body)
            catch error
                console.log "Fehler beim Versuch die Schnittstelle zu ermitteln"
        return

    InitEvents: ->
        self = @
        if @.$loginButton
            if @.loginOverlayId
                @.$loginButton.addEventListener 'click', (e) ->
                    e.preventDefault()
                    document.getElementById self.loginOverlayId
                        .dispatchEvent new CustomEvent 'overlay-show', { bubbles: false }
                    return
            else
                @.$loginButton.remove()
                @.$loginButton = null
        if @.$startQuiz
            @.$startQuiz.addEventListener 'quiz-completed', (e) ->
                fulfilledSheets = e.detail.fulfilledSheets
                if fulfilledSheets
                    self.CreateUserProfile fulfilledSheets
                return
        if @.$startButton
            @.$startButton.addEventListener 'click', (e) ->
                location.href = location.href.replace(/\?.*/, '/')
                return
        if @.$diaryFeelingsEnterButton
            @.$diaryFeelingsEnterButton.addEventListener 'click', (e) ->
                e.preventDefault()
                self.AddDiaryFeelingsEntry()
                return
        if @.$diarySmokedNoButton && @.$diarySmokedYesButton
            @.$diarySmokedNoButton.addEventListener 'click', (e) ->
                e.preventDefault()
                self.UpdateDiarySmoked 'no'
                @.classList.remove 'button--purple'
                @.classList.add "exit-program__diary__smoked__button--active", "button--#{self.diaryButtonActiveColor}"
                return
            @.$diarySmokedYesButton.addEventListener 'click', (e) ->
                e.preventDefault()
                self.UpdateDiarySmoked 'yes'
                @.classList.remove 'button--purple'
                @.classList.add "exit-program__diary__smoked__button--active", "button--#{self.diaryButtonActiveColor}"
                return
        if @.$diaryDemandRangeEl
            @.$diaryDemandRangeEl.addEventListener 'range-value-changed', (e) ->
                window.clearInterval self.demandRangeChangeInterval
                self.demandRangeChangeInterval = window.setInterval ->
                    window.clearInterval self.demandRangeChangeInterval
                    value = e.detail?.value ? false
                    if !isNaN(value)
                        self.UpdateDiaryDemand value
                    return
                , self.demandRangeChangeDelay
                return
        if @.$resetStartButton
            @.$resetStartButton.addEventListener 'click', (e) ->
                e.preventDefault()
                self.ShowResetOverlay()
                return
        return

    ResetStart: ->
        if @.apiBase && @.apiMethod == 'POST'
            self = @
            try
                resetStartOverlay = document.getElementById 'overlay-id_reset-start-overlay'
                smokeStopInDays = 0
                if resetStartOverlay
                    selectElement = resetStartOverlay.querySelector '.exit-program__reset-start-overlay__select select'
                    if selectElement && selectElement.value != ""
                        smokeStopInDays = parseInt(selectElement.value, 10)
                body = {
                    ausstiegUid: @.uid
                    smokeStopInDays: smokeStopInDays
                }
                request = window.appUtils.XMLHttpRequest @.apiMethod, @.apiBase + @.apiResetStart
                    , ->
                        if request.responseText && request.responseText != ""
                            try
                                answer = JSON.parse request.responseText
                                location.reload()
                            catch error
                                console.log "Fehler beim Versuch die Antwort der Schnittstelle zu verarbeiten"
                                return
                        else
                            console.log "Die Anfrage zur Schnittstelle lieferte ein leeres Ergebnis"
                    , ->
                        console.log "Bei der Anfrage an die Schnittstelle ist leider ein Fehler aufgetreten"
                        return
                    , JSON.stringify(body)
            catch error
                console.log "Fehler beim Versuch die Schnittstelle zu ermitteln"
        return
    
    ShowResetOverlay: ->
        self = @
        resetStartOverlayEl = document.getElementById 'reset-start-overlay'
        if resetStartOverlayEl
            resetStartOverlayEl.dispatchEvent new CustomEvent 'overlay-show', {bubbles: false}
            resetStartOverlay = document.getElementById 'overlay-id_reset-start-overlay'
            if resetStartOverlay
                selectElement = resetStartOverlay.querySelector '.exit-program__reset-start-overlay__select select'
                if selectElement
                    selectElement.addEventListener 'change', (e) ->
                        e.preventDefault()
                        self.ResetStart()
                        resetStartOverlayEl.dispatchEvent new CustomEvent 'overlay-close', {bubbles: false}
                        return
        return

    UpdateDiaryDemand: (demand) ->
        if @.apiBase && @.apiMethod == 'POST' && !isNaN(demand)
            self = @
            try
                body = {
                    ausstiegUid: @.uid
                    day: @.shownDay
                    demand: parseInt(demand,10)
                }
                request = window.appUtils.XMLHttpRequest @.apiMethod, @.apiBase + @.apiSaveDemand
                    , ->
                        if request.responseText && request.responseText != ""
                            try
                                answer = JSON.parse request.responseText
                            catch error
                                console.log "Fehler beim Versuch die Antwort der Schnittstelle zu verarbeiten"
                                return
                        else
                            console.log "Die Anfrage zur Schnittstelle lieferte ein leeres Ergebnis"
                    , ->
                        console.log "Bei der Anfrage an die Schnittstelle ist leider ein Fehler aufgetreten"
                        return
                    , JSON.stringify(body)
            catch error
                console.log "Fehler beim Versuch die Schnittstelle zu ermitteln"
        return
    
    UpdateDiaryFeelings: (diaryFeeling) ->
        if @.apiBase && @.apiMethod == 'POST' && diaryFeeling != "" && !isNaN(@.shownDay)
            self = @
            try
                body = {
                    ausstiegUid: @.uid
                    day: @.shownDay
                    feeling: diaryFeeling
                }
                request = window.appUtils.XMLHttpRequest @.apiMethod, @.apiBase + @.apiSaveFeeling
                    , ->
                        if request.responseText && request.responseText != ""
                            try
                                answer = JSON.parse request.responseText
                            catch error
                                console.log "Fehler beim Versuch die Antwort der Schnittstelle zu verarbeiten"
                                return
                        else
                            console.log "Die Anfrage zur Schnittstelle lieferte ein leeres Ergebnis"
                    , ->
                        console.log "Bei der Anfrage an die Schnittstelle ist leider ein Fehler aufgetreten"
                        return
                    , JSON.stringify(body)
            catch error
                console.log "Fehler beim Versuch die Schnittstelle zu ermitteln"
        return
    
    UpdateDiarySmoked: (answer) ->
        if @.$diarySmokedButtonsEl
            activeButton = @.$diarySmokedButtonsEl.querySelector '.exit-program__diary__smoked__button--active'
            if activeButton
                activeButton.classList.remove "exit-program__diary__smoked__button--active", "button--#{@.diaryButtonActiveColor}"
                activeButton.classList.add 'button--purple'
        if @.apiBase && @.apiMethod == 'POST'
            self = @
            try
                body = {
                    ausstiegUid: @.uid
                    day: @.shownDay
                    smoked: if answer == 'yes' then '1' else '0'
                }
                request = window.appUtils.XMLHttpRequest @.apiMethod, @.apiBase + @.apiSaveSmoked
                    , ->
                        if request.responseText && request.responseText != ""
                            try
                                answer = JSON.parse request.responseText
                            catch error
                                console.log "Fehler beim Versuch die Antwort der Schnittstelle zu verarbeiten"
                                return
                        else
                            console.log "Die Anfrage zur Schnittstelle lieferte ein leeres Ergebnis"
                    , ->
                        console.log "Bei der Anfrage an die Schnittstelle ist leider ein Fehler aufgetreten"
                        return
                    , JSON.stringify(body)
            catch error
                console.log "Fehler beim Versuch die Schnittstelle zu ermitteln"
        return

BindExitPrograms = ->
    document.querySelectorAll '.exit-program:not(.exit-program--bound)'
        .forEach (el) ->
            new ExitProgram el
            return
    return

window.addEventListener 'bind-components', BindExitPrograms
window.dispatchEvent new CustomEvent 'bind-components', { bubbles: false }
